<template>
  <SellerComment
    v-if="productResponse && selectedOffer?.sellerComment && hasNoVariants"
    :comment="selectedOffer.sellerComment"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import SellerComment from '~/scopes/product-core/components/presentationals/SellerComment/SellerComment.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const { data: pickersResponse, selectedOffer } = useFetchPickers()

const hasNoVariants = computed(() => {
  return pickersResponse.value?.pickerGroups.length === 0
})
</script>
